import { useTranslate } from 'hooks/useTranslate';
import { FC } from 'react';
import { Modal } from 'react-bootstrap';
import { useRenumerationModal } from '../context/RenumerationModalContext';

const RenumerationModalHeader: FC = () => {
  const { t } = useTranslate();

  const { actions } = useRenumerationModal();

  return (
    <Modal.Header>
      <h5 className="modal-title">{t('Renumeration')}&nbsp;</h5>
      <a className="close cursor-pointer" onClick={actions.handleCloseModal}>
        <em className="icon ni ni-cross" />
      </a>
    </Modal.Header>
  );
};

export default RenumerationModalHeader;
